import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

const Androidbuss = () => {
  return (
    <div className="androidbuss tekrevol_dark_bg p-100">
        <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <h2>Why Do You Need Unity to Create <span>Your Game App?</span></h2>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                       <p>Unity is the essential tool that unlocks endless possibilities, providing versatility, efficient development, and a user-friendly experience for crafting both 2D and 3D games.</p>
                       <p>Here’s why you need to pick Unity to create your mobile game app:</p>
                    </Col>
                </Row>
                <Row className="h-100 buss-padd">
                <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                    <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Versatility in Platform Compatibility</h6>
                            <p>Unity supports various platforms, ensuring your game app runs seamlessly on mobile devices, PCs, and consoles.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Efficient Cross-Platform Development</h6>
                            <p>Unity simplifies the process, allowing developers to effortlessly create and deploy games across different platforms.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Rich 2D and 3D Game Development</h6>
                            <p>Unity empowers you to create visually stunning 2D and immersive 3D games, giving your app a dynamic and engaging edge.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>User-Friendly Interface and Development Tools</h6>
                            <p>With an intuitive interface and user-friendly tools, Unity makes the game creation process smoother and more accessible.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Large Community and Extensive Resources</h6>
                            <p>Benefit from a vast community of developers and extensive resources, ensuring quick problem-solving and continuous learning.</p>
                        </div>
                    </div>
                </Col>
                 <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                 <div className="androidbuss_box">
                        <div className="andoidbuss_content">
                            <h6>Cost-Effective Game Development</h6>
                            <p>Unity provides a cost-effective solution for game development, making it accessible for both indie developers and established studios.</p>
                        </div>
                    </div>
                </Col>
                </Row>
            </Container>
    </div>
  )
}

export default Androidbuss